import React from 'react';
import {
  Layout,
  BetterSectionTabs,
  NewsLetterBar,
} from '../../v2/components/common';
import {
  HomePageHero,
  HomepageBetterForEveryone,
  HomePageCaseStudies,
  HomePageTrustedByNames,
  HomePageReadyToSee,
  HomePageBetterTexts,
} from '../../v2/components/home-page';

const HomePage: React.FC = () => (
  <Layout
    title="Fully Measured, Customizable 3D Models"
    dividerColor="brandTan.400"
    buttonType="SCHEDULE_A_DEMO"
  >
    <HomePageHero />
    <HomepageBetterForEveryone />
    <HomePageBetterTexts />
    <BetterSectionTabs />
    <HomePageCaseStudies />
    <HomePageTrustedByNames />
    <HomePageReadyToSee />
    <NewsLetterBar />
  </Layout>
);

export default HomePage;
